import { ImagePlus, X } from "lucide-react";
import { toast } from "sonner";

const MAX_SIDE = 900;

function resizeImage(file) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      const scale = Math.min(1, MAX_SIDE / Math.max(img.width, img.height));
      const canvas = document.createElement("canvas");
      canvas.width = Math.round(img.width * scale);
      canvas.height = Math.round(img.height * scale);
      canvas.getContext("2d").drawImage(img, 0, 0, canvas.width, canvas.height);
      resolve(canvas.toDataURL("image/jpeg", 0.85));
      URL.revokeObjectURL(img.src);
    };
    img.onerror = reject;
    img.src = URL.createObjectURL(file);
  });
}

export const ImageField = ({ value, onChange }) => {
  const pick = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    if (!file.type.startsWith("image/")) {
      toast.error("Lütfen bir görsel dosyası seçin");
      return;
    }
    onChange(await resizeImage(file));
  };
  if (value) {
    return (
      <div className="relative inline-block">
        <img src={value} alt="Soru görseli" className="max-h-48 rounded-lg border border-[rgba(71,85,105,0.45)]" data-testid="question-image-preview" />
        <button type="button" onClick={() => onChange(null)} className="absolute -top-2 -right-2 bg-red-600 rounded-full p-1" data-testid="question-image-remove" aria-label="Görseli kaldır">
          <X className="h-4 w-4" />
        </button>
      </div>
    );
  }
  return (
    <label className="flex items-center gap-2 w-fit cursor-pointer px-4 py-3 rounded-lg border border-dashed border-[rgba(100,116,139,0.6)] text-slate-300 hover:border-[#FACC15] hover:text-white">
      <ImagePlus className="h-5 w-5" /> Görsel ekle (isteğe bağlı)
      <input type="file" accept="image/*" className="hidden" onChange={pick} data-testid="question-image-input" />
    </label>
  );
};
